/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Hero_WatchInputs */

const en_road_dude_hero_watch = /** @type {(inputs: Road_Dude_Hero_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See video examples`)
};

const zh_road_dude_hero_watch = /** @type {(inputs: Road_Dude_Hero_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看视频案例`)
};

/**
* | output |
* | --- |
* | "See video examples" |
*
* @param {Road_Dude_Hero_WatchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_hero_watch = /** @type {((inputs?: Road_Dude_Hero_WatchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Hero_WatchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_hero_watch(inputs)
	return zh_road_dude_hero_watch(inputs)
});
export { road_dude_hero_watch as "road_dude.hero.watch" }